/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState, createContext } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import firebase from 'firebase';
import fb from 'firebaseConfig';
import * as Sentry from '@sentry/react';
import { getCustomerHash } from 'services/api/customers';
import AlertCookies from 'components/AlertCookies';
// Retorna o idToken do currentUser
export const getIdToken = async (expired = true) => {
  try {
    const data = await fb.auth().currentUser.getIdToken(expired);
    return data;
  } catch (error) {
    // TODO: ERROR TREATMENT
    console.error(error);
  }
};

// Verifica se o idToken do currentUser está expirado
export const verifyIdToken = async () => {
  const currentTime = new Date().getTime();
  try {
    const data = await fb.auth().currentUser.getIdTokenResult();
    const expirationTime = new Date(data.expirationTime).getTime();
    if (currentTime > expirationTime) {
      return getIdToken();
    }
    return data.token;
  } catch (error) {
    // TODO: ERROR TREATMENT
    console.error(error);
  }
};

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  // Observador de alterações no Auth do Firebase
  const onAuthStateChanged = async () => {
    try {
      await fb.auth().onAuthStateChanged((user) => {
        if (user) {
          setCurrentUser(user);
          verifyIdToken();
        } else {
          setCurrentUser(null);
        }
        setLoading(false);
      });
    } catch (error) {
      // TODO: ERROR TREATMENT
      console.error(error);
      setLoading(false);
    }
  };

  // inicialização
  useEffect(() => {
    firebase.analytics();
    onAuthStateChanged();
  }, []);

  const updateUserIntercom = async () => {
    let hash;
    if (!localStorage.getItem('user_hash')) {
      const payload = {
        user_id: `loit_fgts_${currentUser.emailVerified ? currentUser.email : currentUser.phoneNumber || currentUser.email}`,
      };
      try {
        const { data } = await getCustomerHash(payload);
        hash = data.hash;
        localStorage.setItem('user_hash', data.hash);
      } catch (error) {
        const { response } = error;
        if (error.message.includes('timeout')) {
          return updateUserIntercom();
        }
        if (response && response.status === 403) {
          setTimeout(() => updateUserIntercom(), 3000);
        }
      }
    }
    window.Intercom('boot', {
      app_id: 'ajv113fn',
      name: currentUser.displayName && currentUser.displayName,
      phone: currentUser.phoneNumber && currentUser.phoneNumber,
      email: currentUser.email && currentUser.email,
      user_id: `loit_fgts_${currentUser.emailVerified ? currentUser.email : currentUser.phoneNumber || currentUser.email}`,
      user_hash: localStorage.getItem('user_hash') ? localStorage.getItem('user_hash') : hash,
    });
    Sentry.setContext('character', {
      name: currentUser.displayName && currentUser.displayName,
      phone: currentUser.phoneNumber && currentUser.phoneNumber,
      email: currentUser.email && currentUser.email,
    });
  };

  useEffect(() => {
    if (currentUser) {
      setTimeout(() => {
        updateUserIntercom();
      }, 1000);
    } else {
      window.Intercom('shutdown');
      window.Intercom('boot', {
        app_id: 'ajv113fn',
      });
    }
  }, [currentUser]);

  // TODO: CREATE LOADING COMPONENT
  if (loading) {
    return <Loading bg="white" />;
  }

  return (
    <AuthContext.Provider value={{ currentUser }}>
      {children}
      <AlertCookies />
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
